import { Logo } from "./Logo";
import { Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-brand-bg2 border-t border-brand-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <Logo />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-brand-muted">
              Developing, branding and marketing innovative products that address
              everyday household problems — for families all around the world.
            </p>
            <div className="mt-6 flex flex-col gap-3 text-sm text-brand-muted">
              <span className="inline-flex items-center gap-2">
                <Mail size={16} className="text-[#8DC63F]" /> info@hamptondirect.com
              </span>
              <span className="inline-flex items-center gap-2">
                <MapPin size={16} className="text-[#8DC63F]" /> Williston, Vermont, USA
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.15em] text-brand-text">
              Explore
            </h4>
            <ul className="mt-5 space-y-3 text-sm text-brand-muted">
              <li><a href="#products" className="hover:text-[#8DC63F] transition-colors">Products</a></li>
              <li><a href="#categories" className="hover:text-[#8DC63F] transition-colors">Categories</a></li>
              <li><a href="#about" className="hover:text-[#8DC63F] transition-colors">About Us</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.15em] text-brand-text">
              Company
            </h4>
            <ul className="mt-5 space-y-3 text-sm text-brand-muted">
              <li><a href="#about" className="hover:text-[#8DC63F] transition-colors">Our Story</a></li>
              <li><a href="#inventor" className="hover:text-[#8DC63F] transition-colors">Inventor Connection</a></li>
              <li><a href="#about" className="hover:text-[#8DC63F] transition-colors">Careers</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="overflow-hidden border-t border-brand-border select-none">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8">
          <div className="brand-watermark font-heading text-[14vw] leading-none font-bold tracking-tighter">
            Hampton Direct
          </div>
        </div>
      </div>

      <div className="border-t border-brand-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-muted2">
          <span>© {new Date().getFullYear()} Hampton Direct. Enriching Life Through Innovation.</span>
          <span>Proof-of-concept · Not affiliated with the live store</span>
        </div>
      </div>
    </footer>
  );
};
